import { FC } from "react"
import { Link } from "react-router-dom"

interface LinkInBlankWindowProps {
  children: React.ReactNode
  href: string
  className?: string
}

export const LinkInBlankWindow: FC<LinkInBlankWindowProps> = ({ children, href, className }) => {
  return (
    <Link to={href} target="_blank" rel="noopener noreferrer" className={className}>
      {children}
    </Link>
  )
}
